import { render, staticRenderFns } from "./PoweredBy.vue?vue&type=template&id=fa6416ec&scoped=true&"
import script from "./PoweredBy.vue?vue&type=script&lang=js&"
export * from "./PoweredBy.vue?vue&type=script&lang=js&"
import style0 from "./PoweredBy.vue?vue&type=style&index=0&id=fa6416ec&scoped=true&lang=scss&"
import style1 from "./PoweredBy.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6416ec",
  null
  
)

export default component.exports